<div class="dialog-header flex align-items-center justify-content-between w-full">
  <div class="flex flex-1 justify-content-between align-items-center">
    <div class="flex flex-column">
      <h2>Detalii {{ lockerIdentifier }}</h2>
      <div class="flex align-items-center gap-1">
        <p-tag
          [value]="lockerData()?.state?.isConfigured ? 'Configurat' : 'Neconfigurat'"
          [severity]="lockerData()?.state?.isConfigured ? 'success' : 'danger'"
        ></p-tag>
        <p-tag
          [value]="lockerData()?.state?.isOnline ? 'Online' : 'Offline'"
          [severity]="lockerData()?.state?.isOnline ? 'success' : 'danger'"
        ></p-tag>
        <p-tag
          [value]="lockerData()?.state?.isActive ? 'Activ' : 'Inactiv'"
          [severity]="lockerData()?.state?.isActive ? 'success' : 'danger'"
        ></p-tag>
      </div>
      <small class="flex align-items-center gap-2 mt-2">
        <span class="flex align-items-center gap-1" pTooltip="Stare imprimantă" tooltipPosition="top">
          <span class="material-symbols-rounded md-18">print</span>
          @let printerState = lockerData()?.options?.printer?.state;
          <span class="m-0" [ngClass]="{
            'text-yellow-500': printerState === 'UNKNOWN' || printerState === 'OUT_OF_PAPER',
            'text-red-500': printerState === 'NOT_OK',
            'text-green-500': printerState === 'OK'
          }">
            @if (printerState === "UNKNOWN") {
              Stare necunoscută
            } @else if (printerState === "NOT_OK") {
              Nefuncțional
            } @else if (printerState === "OK") {
              Funcțional
            } @else if (printerState === "OUT_OF_PAPER") {
              Fară hârtie
            }
          </span>
        </span>
        <p-divider styleClass="h-1rem py-1 m-0" layout="vertical"></p-divider>
        <span class="flex align-items-center gap-1" pTooltip="Stare POS" tooltipPosition="top">
          <span class="material-symbols-rounded md-18">credit_card</span>
          @let paymentState = lockerData()?.options?.payment?.state;
          <span class="m-0" [ngClass]="{
            'text-yellow-500': paymentState === 'UNKNOWN',
            'text-red-500': paymentState === 'NOT_OK',
            'text-green-500': paymentState === 'OK'
          }">
            @if (paymentState === "UNKNOWN") {
              Stare necunoscută
            } @else if (paymentState === "NOT_OK") {
              Nefuncțional
            } @else if (paymentState === "OK") {
              Funcțional
            }
          </span>
        </span>
        <p-divider styleClass="h-1rem py-1 m-0" layout="vertical"></p-divider>
        <span class="flex align-items-center gap-1" pTooltip="Stare scanner" tooltipPosition="top">
          @let scannerState = lockerData()?.options?.scanner?.state;
          <span class="material-symbols-rounded md-18">qr_code_scanner</span>
          <span class="m-0" [ngClass]="{
            'text-yellow-500': scannerState === 'UNKNOWN',
            'text-red-500': scannerState === 'NOT_OK',
            'text-green-500': scannerState === 'OK'
          }">
            @if (scannerState === "UNKNOWN") {
              Stare necunoscută
            } @else if (scannerState === "NOT_OK") {
              Nefuncțional
            } @else if (scannerState === "OK") {
              Funcțional
            }
          </span>
        </span>
        <button
          pButton
          data-testid="row-action-equipment-status"
          size="small"
          class="py-1 px-2 text-xs white-space-nowrap"
          (click)="updateEquipmentsStatus()"
        >
          <span class="material-symbols-rounded md-18">edit</span>
          <span class="font-bold">Actualizează status</span>
        </button>
      </small>
    </div>
  </div>
  <p-button
    mat-dialog-close
    data-testid="dialog-secondary"
    size="small"
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>
<mat-dialog-content>
  @if (!loading()) {

    <div class="grid">
      <div class="col-12">
        <div
          class="card h-full shadow-1 border-round flex justify-content-between align-items-center gap-2 p-2"
          [class.bg-orange-100]="!lockerData()?.softwareVersion?.isLatest"
          [class.border-1]="!lockerData()?.softwareVersion?.isLatest"
          [class.border-orange-500]="!lockerData()?.softwareVersion?.isLatest"
        >
          <div class="flex flex-column">
            <p class="m-0 font-bold">Versiune: {{ lockerData()?.softwareVersion?.name }}</p>
            @if (!lockerData()?.softwareVersion?.isLatest) {
              <p class="m-0 text-2xs">Este disponibilă o nouă versiune a aplicației</p>
            }
          </div>
          <p-button
            data-testid="row-action-update-software"
            styleClass="p-2 text-xs"
            iconPos="left"
            icon="pi pi-sync"
            [label]="'Actualizeaza la ' + lockerData()?.softwareVersion?.latestVersionName"
            (click)="updateLocker()"
          ></p-button>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
          <app-cbox-to-do-list
            [lockerIdentifiers]="[lockerIdentifier]"
          ></app-cbox-to-do-list>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
          <h2 class="m-0 mb-2">Configurare</h2>
          <div class="flex align-items-center justify-content-center">
          @if (dataFetched()["lockerData"]) {
            <img class="max-w-15rem" [src]="lockerData()?.internalIdentifier?.image">
          } @else {
            <p-progressSpinner></p-progressSpinner>
          }
          </div>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
          <h2 class="m-0 mb-2">Module</h2>
          @if (dataFetched()["modules"] && !hasKeys(modulesData())) {
            <p class="flex align-items-center justify-content-center h-full text-gray-400">Nu există module asociate</p>
          } @else {
            @for (module of modules(); track $index) {
              <div
                class="
                  flex flex-nowrap justify-content-between align-items-center border-1
                  surface-border border-round py-3 px-3 cursor-pointer select-none hover:surface-hover
                  transition-colors transition-duration-150
                "
                (click)="openModuleDataDialog(module.id)"
              >
                <div class="flex flex-column flex-nowrap">
                  <p class="m-0 text-lg">
                    <b>{{ module.serial }}</b>
                  </p>
                  <p class="text-gray-400 m-0">
                    {{ module.type.description }}
                  </p>
                  <!-- @if (modulesData()[module.id]) {
                    @let necesarryEquipments = getModuleNecesarryEquipmentsCount(module.id);
                    @if (!!necesarryEquipments) {
                      <p class="text-red-500 m-0 -mt-1 text-xs">{{ necesarryEquipments < 2 ? "Un" : necesarryEquipments}} {{ necesarryEquipments < 2 ? "echipament necesar" : "echipamente necesare" }}</p>
                    }
                  } -->
                </div>
                @if (modulesData()[module.id]) {
                  @let moduleData = modulesData()[module.id];
                  <div class="flex flex-nowrap gap-2 align-items-center">
                    @if (!!getModuleNecessaryEquipmentsCount(module.id)) {
                      <b class="text-red-500">{{ getModuleNecessaryEquipmentsCount(module.id) }}</b>
                      <span class="material-symbols-rounded text-red-500">priority_high</span>
                    } @else {
                      @if (moduleData?.equipments?.length) {
                        <b>{{ moduleData?.equipments?.length }}</b>
                        <span class="material-symbols-rounded">build</span>
                      }
                    }
                  </div>

                } @else {
                  <p-progressSpinner
                    [style]="{
                      width: '1rem',
                      height: '1rem',
                    }"
                  ></p-progressSpinner>
                }
              </div>
            }
          }
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
          <h2 class="m-0 mb-2">Echipamente</h2>
          @if (dataFetched()["modules"] && !hasKeys(modulesData())) {
            <p class="flex align-items-center justify-content-center h-full text-gray-400">Nu există echipamente asociate</p>
          } @else if (equipmentsReady()) {
            <p-table
              styleClass="p-datatable-sm p-datatable-striped"
              [value]="equipments()"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Tip</th>
                  <th>Serie</th>
                  <th>Modul</th>
                  <th></th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-equipment>
                <tr class="transition-duration-200 transition-colors cursor-pointer hover:surface-200">
                  <td>{{equipment.type.name}}</td>
                  <td>{{ equipment.internalSerial }}</td>
                  <td>{{ equipment.module.serial }}</td>
                  <td class="text-right">
                    <button
                      pButton
                      size="small"
                      class="py-1 px-2 text-xs white-space-nowrap"
                      (click)="createEquipmentToDo(equipment)"
                    >
                      <span class="material-symbols-rounded md-18">add</span>
                      <span class="font-bold">To do</span>
                    </button>
                  </td>
                  <td class="text-right">
                    <button
                      pButton
                      [pTooltip]="'Actualizează echipament'"
                      tooltipPosition="right"
                      icon="pi pi-sync"
                      class="p-button-rounded p-button-text"
                      (click)="openUpdateDialog(equipment)"
                    >
                    </button>
                    @if (equipment.type.name === "Terminal Card") {
                      <button
                        pButton
                        [pTooltip]="'Settlement'"
                        tooltipPosition="right"
                        icon="pi pi-credit-card"
                        class="p-button-rounded p-button-text"
                        (click)="settleCardTerminal(equipment)"
                      >
                      </button>
                    }
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="3">
                    Nu există echipamente.
                  </td>
                </tr>
              </ng-template>
            </p-table>
          } @else {
            <p-skeleton
              styleClass="w-full"
              height="10rem"
              borderRadius=".5rem"
            ></p-skeleton>
          }
        </div>
      </div>

      @if (lockerData()?.heartbeat) {
        @if (lockerData()?.heartbeat?.data?.memory) {
          <div class="col-12 md:col-6">
            <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
              <h2 class="m-0 mb-2">RAM</h2>
              <p-meterGroup [value]="memoryMeterItems()" />
            </div>
          </div>
        }

        @if (lockerData()?.heartbeat?.data?.storage) {
          <div class="col-12 md:col-6">
            <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
              <h2 class="m-0 mb-2">HDD</h2>
              <p-meterGroup [value]="storageMeterItems()" />
            </div>
          </div>
        }
      } @else {
        <div class="col-12 md:col-6">
          <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
            <h2 class="m-0 mb-2">RAM</h2>
            <p class="flex align-items-center justify-content-center h-full text-gray-400">Nu există date despre RAM</p>
          </div>
        </div>

        <div class="col-12 md:col-6">
          <h2 class="m-0 mb-2">HDD</h2>
          <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
            <p class="flex align-items-center justify-content-center h-full text-gray-400">Nu există date despre HDD</p>
          </div>
        </div>
      }

      <div class="col-12 md:col-6">
        <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
          <div class="flex align-items-center gap-2 mb-2">
            <h2 class="m-0">Adresă</h2>
            <span
              class="material-symbols-rounded cursor-pointer hover:opacity-50"
              data-testid="row-action-config"
              (click)="configLocker()"
            >edit</span>
          </div>
          @if (dataFetched()["lockerData"]) {
            <p>{{ lockerCleanAddress() }}</p>
          } @else {
            <p-progressSpinner></p-progressSpinner>
          }
        </div>
      </div>

      @if (lockerData()?.heartbeat) {
        <div class="col-12 md:col-6">
          <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
            <h2 class="m-0">Heartbeat</h2>
            <p class="m-0">
              Count: {{ lockerData()?.heartbeat?.count }}
              /
              Uptime: {{ formatTimeInMilliseconds(lockerData()?.heartbeat?.data?.uptime) }}
              @if (lockerData()?.heartbeat?.lastPingAt) {
                /
                <!-- Pass 2 to the function to check if 3 minutes has passed -->
                Last ping at: <span
                  [class.text-red-500]="lockerExtras()?.isOldHeartbeat"
                >{{ formatDate(lockerData()?.heartbeat?.lastPingAt) }}</span>
              }
            </p>
            <p class="m-0">
              <span
                [class.text-red-500]="!lockerData()?.heartbeat?.data?.messageBroker?.available"
                [class.text-green-500]="lockerData()?.heartbeat?.data?.messageBroker?.available"
              >Broker: {{ lockerData()?.heartbeat?.data?.messageBroker?.available ? "Activ" : "Inactiv" }}</span>
              /
              Evenimente cu eroare:
              <span [class.text-red-500]="lockerData()?.heartbeat?.data?.events?.failedCount && lockerData()?.heartbeat?.data?.events?.failedCount! > 0">{{ lockerData()?.heartbeat?.data?.events?.failedCount }}</span>
            </p>
          </div>
        </div>
      } @else {
        <div class="col-12 md:col-6">
          <div class="card h-full shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
            <h2 class="m-0">Heartbeat</h2>
            <p class="flex align-items-center justify-content-center h-full text-gray-400">Nu există date despre heartbeat</p>
          </div>
        </div>
      }

      @let events = lockerData()?.heartbeat?.data?.events;
      @if ((events?.failedEvents ?? []).length > 0) {
        <div class="col-12 md:col-12">
         <app-failed-events-table
            [lockerIdentifier]="lockerIdentifier"
           [failedEvents]="events!.failedEvents!"
           [markedForProcessing]="events!.markedForProcessing!"
           (dirty)="init()"
         />
        </div>
      }

      <div class="col-12 md:col-4">
        @let brokenDoorsMatchValue = getHashMatchValue("BROKEN_DOORS");
        <div [ngClass]="{
          'bg-red-100': brokenDoorsMatchValue === 'DRIFT',
          'border-red-500': brokenDoorsMatchValue === 'DRIFT',
          'bg-orange-100': brokenDoorsMatchValue === 'UNKNOWN',
          'border-orange-500': brokenDoorsMatchValue === 'UNKNOWN',
          'border-1': brokenDoorsMatchValue === 'DRIFT' || brokenDoorsMatchValue === 'UNKNOWN',

        }" class="card h-full shadow-1 border-round flex justify-content-between align-items-center gap-2 p-2">
          <div class="flex justify-content-between">
            <div class="flex align-items-center gap-2">
              @switch (brokenDoorsMatchValue) {
                @case ("MATCH") {
                  <div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-green-500 text-white">
                    <span class="pi pi-sync"></span>
                  </div>
                }

                @case ("DRIFT") {
                  <div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-red-500 text-white">
                    <span class="pi pi-sync"></span>
                  </div>
                }

                @case ("UNKNOWN") {
                  <div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-orange-500 text-white">
                    <span class="pi pi-sync"></span>
                  </div>
                }
              }
              <h3 class="m-0">Uși stricate</h3>
            </div>
          </div>
          <div>
            @switch (brokenDoorsMatchValue) {
              @case ("MATCH") {
                <b class="text-green-500">SINCRONIZAT</b>
              }

              @case ("DRIFT") {
                <b class="text-red-500">DESINCRONIZAT</b>
              }

              @case ("UNKNOWN") {
                <b class="text-orange-500">NECUNOSCUT</b>
              }
            }
          </div>
        </div>
      </div>

      <div class="col-12 md:col-4 opacity-60">
        @let filledDoorsMatchValue = getHashMatchValue("BROKEN_DOORS");
        <div class="card h-full shadow-1 border-round flex justify-content-between align-items-center gap-2 p-2">
          <div class="flex justify-content-between">
            <div class="flex align-items-center gap-2">
              @switch (filledDoorsMatchValue) {
                @case ("MATCH") {
                  <div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-green-500 text-white">
                    <span class="pi pi-sync"></span>
                  </div>
                }

                @case ("DRIFT") {
                  <div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-red-500 text-white">
                    <span class="pi pi-sync"></span>
                  </div>
                }

                @case ("UNKNOWN") {
                  <div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle bg-orange-500 text-white">
                    <span class="pi pi-sync"></span>
                  </div>
                }
              }
              <h3 class="m-0">Uși ocupate</h3>
            </div>
          </div>
          <div>
            <b>NEIMPLEMENTAT</b>
            <!-- @switch (filledDoorsMatchValue) {
              @case ("MATCH") {
                <b class="text-green-500">SINCRONIZAT</b>
              }

              @case ("DRIFT") {
                <b class="text-red-500">DESINCRONIZAT</b>
              }

              @case ("UNKNOWN") {
                <b class="text-orange-500">NECUNOSCUT</b>
              }
            } -->
          </div>
        </div>
      </div>

      <div class="col-12 md:col-4">

      </div>

      @if (lockerSVGs()) {
      <div class="col-12 md:col-12">
        <app-locker-preview
          [modulesIndexes]="modulesIndexes()"
          [lockerIdentifier]="lockerIdentifier"
          [SVGs]="lockerSVGs()"
          [itemData]="itemData()"
          />
      </div>
    }

      <div class="col-12">
        <div class="card shadow-1 border-round flex flex-column align-items-between gap-2 p-4">
          <div class="flex align-items-center mb-2">
            <h2 class="m-0 mb-2">Istoric Comenzi</h2>
            @if (commandStatusLoading()) {
              <p-progressSpinner  [style]="{
                      width: '1rem',
                      height: '1rem',
                    }" />
            }
          </div>
          <p-table
            styleClass="p-datatable-sm p-datatable-striped"
            [value]="commandStatusList()"
            [rowHover]="true"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Tip Acțiune</th>
                <th>Stare</th>
                <th>Executat de</th>
                <th>Box ID</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-command>
              <tr (click)="openCommandDetails(command)" class="cursor-pointer">
                <td>{{ command.actionType }}</td>
                <td>
                  <p-tag
                    [value]="command.state"
                    [severity]="getCommandStateSeverity(command.state)"
                  ></p-tag>
                </td>
                <td>{{ command.performedBy.name }}</td>
                @let uniqueBoxId = (command.doorAction?.uniqueBoxId | json);
                <td>{{ uniqueBoxId === "null" ? '-' : uniqueBoxId }}</td>
                <td class="text-right">
                  <button
                    pButton
                    icon="pi pi-info-circle"
                    class="p-button-rounded p-button-text"
                    (click)="openCommandDetails(command); $event.stopPropagation()"
                  ></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6" class="text-center">
                  Nu există comenzi.
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            [rows]="commandStatusPagination().pageSize"
            [totalRecords]="commandStatusPagination().totalRecords"
            [rowsPerPageOptions]="[10, 25, 50]"
            (onPageChange)="onCommandPageChange($event)"
          ></p-paginator>
        </div>
      </div>
    </div>
  } @else {
    <p-progressSpinner class="w-full flex justify-content-center" />
  }



</mat-dialog-content>
